module.exports = __webpack_public_path__ + "img/content_paste_outlined.529cd78a.svg";